module.exports = __webpack_public_path__ + "static/media/follow-us-on-facebook.acbf0766.png";